import { AiSparkleIcon, AddMiniIcon } from '@calendly/ui/components/icons'
import {
  colorBackgroundMeetingIntelligence,
  colorBackgroundStandard,
  colorStrokeFocus,
  colorStrokeMeetingIntelligence,
  colorSurfaceAction,
  colorSurfaceActionMeetingIntelligence,
  colorSurfaceActionSecondary,
  colorTextStandard,
} from '@calendly/ui/theme'

import {
  ArrowLeft,
  ArrowLeftMI,
  ArrowRight,
  ArrowRightMI,
  ArrowDown,
  ArrowDownMI,
  ArrowUp,
  ArrowUpMI
} from './assets'

export const THEMES = {
  classic: {
    textColor: colorTextStandard,
    backgroundColor: colorSurfaceActionSecondary,
    borderColor: colorStrokeFocus,
    secondaryButtonColor: colorTextStandard,
    secondaryButtonIcon: AddMiniIcon,
    primaryButtonColor: colorSurfaceAction,
    primaryButtonType: 'primary',
    arrowIconSource: {
      right: ArrowLeft,
      left: ArrowRight,
      top: ArrowDown,
      bottom: ArrowUp
    },
    buttonWidth: 'unset',
    maxWidth: '300px',
    textDecoration: 'underline'
  },
  meeting_intelligence: {
    textColor: colorTextStandard,
    backgroundColor: colorBackgroundMeetingIntelligence,
    borderColor: colorStrokeMeetingIntelligence,
    secondaryButtonColor: colorTextStandard,
    primaryButtonColor: colorSurfaceActionMeetingIntelligence,
    primaryButtonType: 'meeting-intelligence',
    primaryButtonIcon: AiSparkleIcon,
    primaryButtonIconColor: colorBackgroundStandard,
    arrowIconSource: {
      right: ArrowLeftMI,
      left: ArrowRightMI,
      top: ArrowDownMI,
      bottom: ArrowUpMI
    },
    buttonWidth: 'auto',
    gap: '0',
    maxWidth: '100%',
    textDecoration: 'none',
    mobileMaxWidth: '100%'
  },
  meeting_intelligence_simplified: {
    textColor: colorTextStandard,
    backgroundColor: colorBackgroundMeetingIntelligence,
    borderColor: colorStrokeMeetingIntelligence,
    secondaryButtonColor: colorTextStandard,
    primaryButtonColor: colorSurfaceActionMeetingIntelligence,
    primaryButtonType: 'meeting-intelligence',
    primaryButtonIconColor: colorBackgroundStandard,
    arrowIconSource: {
      right: ArrowLeftMI,
      left: ArrowRightMI,
      top: ArrowDownMI,
      bottom: ArrowUpMI
    },
    buttonWidth: 'auto',
    maxWidth: '100%',
    textDecoration: 'none',
    bodyTextSize: 'large',
    useTextColor: true,
    isExtended: true,
  },
  meeting_recap_tour: {
    textColor: colorTextStandard,
    backgroundColor: colorSurfaceActionSecondary,
    borderColor: `color-mix(in srgb, ${colorStrokeFocus} 50%, transparent)`,
    secondaryButtonColor: colorTextStandard,
    primaryButtonColor: colorSurfaceAction,
    primaryButtonType: 'primary',
    primaryButtonIcon: null,
    primaryButtonIconColor: colorBackgroundStandard,
    arrowIconSource: {
      right: ArrowLeft,
      left: ArrowRight,
      top: ArrowDown,
      bottom: ArrowUp
    },
    buttonWidth: 'auto',
    maxWidth: '300px',
    textDecoration: 'none',
  }
}
